export type NumberRange = {
  min: number
  max: number
}

export function parseIntegerDraft(value: string) {
  const trimmed = value.trim()
  if (trimmed === "" || !/^[+-]?\d+$/.test(trimmed)) return null

  const parsed = Number(trimmed)
  return Number.isSafeInteger(parsed) ? parsed : null
}

export function parseNumberDraft(value: string) {
  const trimmed = value.trim()
  if (trimmed === "" || trimmed === "." || trimmed === "-" || trimmed === "+") {
    return null
  }

  const parsed = Number(trimmed)
  return Number.isFinite(parsed) ? parsed : null
}

export function inNumberRange(
  value: number | null,
  range: NumberRange,
): value is number {
  return value !== null && value >= range.min && value <= range.max
}
